import { generateManagerName } from '../config/staffNames.js';

let _nextId = 1;
function generateId() { return 'mgr_' + (_nextId++); }

const TIER_SALARIES = {
  junior: 300,
  senior: 800,
  expert: 2000
};

// Actions available at each tier (cumulative)
export const TIER_ACTIONS = {
  junior: ['buy', 'sell', 'sell_all', 'refuel', 'wait'],
  senior: ['buy', 'sell', 'sell_all', 'refuel', 'wait', 'warehouse_load', 'warehouse_unload', 'interest_buy'],
  expert: ['buy', 'sell', 'sell_all', 'refuel', 'wait', 'warehouse_load', 'warehouse_unload', 'interest_buy', 'smart_buy', 'smart_sell', 'smart_refuel']
};

export class RouteManager {
  constructor(config) {
    this.id              = config.id || generateId();
    const m = this.id.match(/^mgr_(\d+)$/);
    if (m) _nextId = Math.max(_nextId, parseInt(m[1], 10) + 1);

    this.name            = config.name || generateManagerName();
    this.skillTier       = config.skillTier || 'junior';
    this.dailySalary     = config.dailySalary || TIER_SALARIES[this.skillTier] || 300;
    this.hireDate        = config.hireDate || null;
    this.assignedRouteId = config.assignedRouteId || null;
  }

  canPerformAction(actionType) {
    const allowed = TIER_ACTIONS[this.skillTier] || TIER_ACTIONS.junior;
    return allowed.includes(actionType);
  }

  serialize() {
    return {
      id:              this.id,
      name:            this.name,
      skillTier:       this.skillTier,
      dailySalary:     this.dailySalary,
      hireDate:        this.hireDate ? (this.hireDate instanceof Date ? this.hireDate.toISOString() : this.hireDate) : null,
      assignedRouteId: this.assignedRouteId
    };
  }

  static deserialize(data) {
    return new RouteManager({
      ...data,
      hireDate: data.hireDate ? new Date(data.hireDate) : null
    });
  }
}
